// hooks/useDataDogUserInit.ts
import { useQuery } from "@tanstack/react-query";
import { AnalyticsUtils } from "@/shared/utils/AnalyticsUtils";
import { Quote } from "../types/Quote.interface";

export const useDataDogUserInit = (quote?: Quote) => {
    return useQuery({
        queryKey: ["dataDogUserInit", quote?.email],
        queryFn: async () => {
            if (quote?.email) {
                // If we have a quote with email, let identifyUser handle it
                return null;
            }

            try {
                const fallbackUserId = await AnalyticsUtils.getDataDogFallbackUserId();
                AnalyticsUtils.setDataDogUser(fallbackUserId);
                return true;
            } catch (error) {
                console.error("Error initializing DataDog user:", error);
                throw error;
            }
        },
        enabled: typeof window !== "undefined" && !quote?.id && !quote?.email,
        retry: 3,
        retryDelay: attemptIndex => Math.min(1000 * 2 ** attemptIndex, 30000),
        staleTime: Infinity,
        refetchOnWindowFocus: false,
        refetchOnMount: false
    });
};
